import { format } from "date-fns";
import clsx from "clsx";

import { QueryMessageModel, AttachmentModel } from "@interfaces/index";
import { PaperClipSvg, ArrowUpRightSvg } from "@components/index";

export const QueryMessage = ({
  message,
  onPreviewAttachment,
}: {
  message: QueryMessageModel;
  onPreviewAttachment: (attachment: AttachmentModel) => void;
}) => {
  const isClient = message.sender === "client";

  return (
    <div
      className={clsx(
        "flex flex-col gap-y-1",
        isClient ? "items-end" : "items-start",
      )}
    >
      <div
        className={clsx(
          "max-w-[75%] rounded-2xl px-4 py-3",
          isClient
            ? "rounded-br-sm bg-primary-108 text-primary-300"
            : "rounded-bl-sm bg-black-4 text-black-100",
        )}
      >
        {message.body && (
          <p className="text-300 leading-snug">{message.body}</p>
        )}
        {(message.attachments.length > 0 || message.links.length > 0) && (
          <div className={clsx("flex flex-wrap gap-2", message.body && "mt-2")}>
            {message.attachments.map((attachment) => (
              <button
                key={attachment.uniqueId}
                type="button"
                onClick={() => onPreviewAttachment(attachment)}
                className="flex items-center gap-x-1 rounded-lg border border-primary-100 bg-white-100 px-2.5 py-1.5 text-primary-300 transition-opacity hover:opacity-70"
              >
                <div className="*:size-5 *:shrink-0">
                  <PaperClipSvg />
                </div>
                <span className="text-100">{attachment.originalName}</span>
              </button>
            ))}
            {message.links.map(({ id, label, type }) => {
              let href;
              switch (type) {
                case "asset":
                  href = `/assets/${id}`;
                  break;
                case "transaction":
                  href = `/transactions/details/${id}`;
                  break;
                case "mileage":
                  href = `/mileage/${id}`;
                  break;
              }

              return (
                href && (
                  <a
                    key={id}
                    href={href}
                    target="_blank"
                    rel="noreferrer"
                    className="flex items-center gap-x-1 rounded-lg border border-primary-100 bg-white-100 px-2.5 py-1.5 text-primary-300 transition-opacity hover:opacity-70"
                  >
                    <div className="*:size-5 *:shrink-0">
                      <ArrowUpRightSvg />
                    </div>
                    <div className="flex items-center gap-x-1">
                      <div className="rounded-lg bg-primary-100 px-1.5 py-0.5 text-90 text-white-100">
                        {type}
                      </div>
                      <div className="text-100">{label}</div>
                    </div>
                  </a>
                )
              );
            })}
          </div>
        )}
      </div>
      <span className="text-90 text-black-32">
        {isClient ? "You" : message.author} ·{" "}
        {format(new Date(message.sentAt), "d MMM yyyy, HH:mm")}
      </span>
    </div>
  );
};
